import React from 'react';
import './Score.css';
import { ChevronUp, TrendingUp, Info, Plus, Minus } from 'react-feather';
import { getScoreText } from '../../../constants';
import { Card, Col, Row } from 'react-bootstrap';
import InfoPopover from '../InfoPopover';
import WorkoutBot from '../../../assets/img/got-some-work-bot.png';
import { getScoreColor } from '../../../constants';

export default function Score({ scores }) {
  const { transunion, experian, equifax } = scores;


  const NaNaNaFix = ({ bureau }) => {
    const htmlContent = `
    <img src=${WorkoutBot} class="img-fluid" alt="Workout Bot">
    <p>You've got some work to do! N/A (Not Applicable) has been designated as your credit score for ${bureau} because you have almost no credit information reporting on your reports. How can you compile a credit score with no data?!</p>
    <p>Although this is concerning, having an N/A score means you have all the opportunity to start building your ideal credit score from the bottom up! Your credit score can only go up from here! You have a clean slate, and what you start doing today will help you begin building a healthy credit score!</p>
  `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };
  return (
    <>
      <style>
        {`
        .noCreditScore {
         position: absolute;
left: -14px;
top: 1px;
        }
        `}
      </style>
      <Card className='border-0 rounded-3 shadow mb-0'>
        <Card.Body className='d-flex flex-row px-md-5 px-3 justify-content-between'>
          <Col lg={3} className='pe-3 pe-md-0'>
            <div className='d-flex flex-column justify-content-md-between justify-content-center m-auto align-content-center'>
              <div className='text-regular-18 fw-light'>TransUnion {transunion.value === '660*' && <InfoPopover headerContent='Total Revolving Accounts' bodyContent={NaNaNaFix({ bureau: 'TransUnion' })} iconMargin={1} />}</div>
              <div className='d-flex flex-md-row flex-column align-items-center'>
                <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                  {transunion.value}
                </div>
                {transunion.percent != null && (
                  <div className='ms-md-3 ms-0'>
                    <div className={`${transunion.percent >= 0 ? 'text-success' : 'text-danger'} ${transunion.label !== 'NO CREDIT SCORE' ? 'badge d-flex my-auto me-0 px-2 py-1 ' : ''} ${transunion.percent >= 0 ? 'bg-success' : 'bg-danger'}  bg-opacity-10`}>
                      <span style={{ fontSize: '19px', fontWeight: '500' }}>
                        {' '}
                        {transunion.percent >= 0 ? <Plus size='15' fill='currentColor' className='me-2' /> : <Minus size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />} {Math.abs(transunion.percent)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className='d-flex align-items-center mt-2 position-relative'>
                {transunion.label !== 'NO CREDIT SCORE' && (
                  <div>
                    <span style={{ fontSize: '0px', fontWeight: '300' }} className={`d-flex bg-${transunion.label ? getScoreColor[transunion.label] : getScoreColor[getScoreText(transunion.value)]} p-1 rounded-circle mx-auto me-2`}></span>
                  </div>
                )}
                <div className={`text-gray-400 my-auto ${transunion.label === 'NO CREDIT SCORE' ? 'noCreditScore' : ''}`}>{transunion.label ? transunion.label.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase()) : getScoreText(transunion.value)}</div>
              </div>
            </div>
          </Col>
          <div className='col-auto ps-5 border-start'></div>
          <Col lg={3} className='pe-3 pe-md-0'>
            <div className='d-flex flex-column justify-content-md-between justify-content-center m-auto align-content-center'>
              <div className='text-regular-18 fw-light'>Experian {experian.value === '660*' && <InfoPopover headerContent='Total Revolving Accounts' bodyContent={NaNaNaFix({ bureau: 'Experian' })} iconMargin={1} />}</div>
              <div className='d-flex flex-md-row flex-column align-items-center'>
                <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                  {experian.value}
                </div>
                {experian.percent != null && (
                  <div className='ms-md-3 ms-0'>
                    <div className={`d-flex my-auto me-0 px-2 py-1 ${experian.percent >= 0 ? 'text-success' : 'text-danger'} badge ${experian.percent >= 0 ? 'bg-success' : 'bg-danger'} bg-opacity-10`}>
                      <span style={{ fontSize: '19px', fontWeight: '500' }}>
                        {' '}
                        {experian.percent >= 0 ? <Plus size='15' fill='currentColor' className='me-2' /> : <Minus size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />} {Math.abs(experian.percent)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className='d-flex align-items-center mt-2 position-relative'>
                {experian.label !== 'NO CREDIT SCORE' && (
                  <div>
                    <span style={{ fontSize: '0px', fontWeight: '300' }} className={`d-flex bg-${experian.label ? getScoreColor[experian.label] : getScoreColor[getScoreText(experian.value)]} p-1 rounded-circle mx-auto me-2`}></span>
                  </div>
                )}
                <div className={`text-gray-400 my-auto ${experian.label === 'NO CREDIT SCORE' ? 'noCreditScore' : ''}`}>{experian.label ? experian.label.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase()) : getScoreText(experian.value)}</div>
              </div>
            </div>
          </Col>
          <div className='col-auto ps-5 border-start'></div>
          <Col lg={3} className='pe-3 pe-md-0'>
            <div className='d-flex flex-column justify-content-md-between justify-content-center m-auto align-content-center'>
              <div className='text-regular-18 fw-light'>Equifax {equifax.value === '660*' && <InfoPopover headerContent='Total Revolving Accounts' bodyContent={NaNaNaFix({ bureau: 'Equifax' })} iconMargin={1} />}</div>
              <div className='d-flex flex-md-row flex-column align-items-center'>
                <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                  {equifax.value}
                </div>
                {equifax.percent != null && (
                  <div className='ms-md-3 ms-0'>
                    <div className={`d-flex my-auto me-0 px-2 py-1 ${equifax.percent >= 0 ? 'text-success' : 'text-danger'} badge ${equifax.percent >= 0 ? 'bg-success' : 'bg-danger'} bg-opacity-10`}>
                      <span style={{ fontSize: '19px', fontWeight: '500' }}>
                        {' '}
                        {equifax.percent >= 0 ? <Plus size='15' fill='currentColor' className='me-2' /> : <Minus size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />} {Math.abs(equifax.percent)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className='d-flex align-items-center mt-2 position-relative'>
                {equifax.label !== 'NO CREDIT SCORE' && (
                  <div>
                    <span style={{ fontSize: '0px', fontWeight: '300' }} className={`d-flex bg-${equifax.label ? getScoreColor[equifax.label] : getScoreColor[getScoreText(equifax.value)]} p-1 rounded-circle mx-auto me-2`}></span>
                  </div>
                )}
                <div className={`text-gray-400 my-auto ${equifax.label === 'NO CREDIT SCORE' ? 'noCreditScore' : ''}`}>{equifax.label ? equifax.label.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase()) : getScoreText(equifax.value)}</div>
              </div>
            </div>
          </Col>
        </Card.Body>
      </Card>
    </>
  );
}
